import { Typography } from '@mui/material';

export const SectionHeader = ({ title }: { title: string }) => {
  return (
    <Typography variant="overline" fontSize="0.75rem">
      {title}
    </Typography>
  );
};
